import React, { useContext, useEffect, useState } from "react";
import { DataContext } from "../contexts/DataContext";

const Pages = () => {
  const { articleListPosition, setArticleListPosition, rawArticleTotal } =
    useContext(DataContext);
  const [pageSelected, setPageSelected] = useState(1);

  // config settings for paginator
  let numberOfPages = 1,
    lookAheadRange = 1,
    spliceVal = 3,
    pageSelectedRangeVal = 2;

  let pagesArray = [];
  if (rawArticleTotal / 200 > 1) {
    numberOfPages = Math.ceil(rawArticleTotal / 200);

    for (var i = 1; i <= numberOfPages; i++) {
      pagesArray.push({ val: i, ahead: i * 200 });
    }
  }

  // trim pages array if exceeding the 'look ahead' to prevent hundreds of buttons being generated
  if (pagesArray.length > lookAheadRange) {
    // trim lower and upper parts of the array based on pageSelected and how many pages
    if (numberOfPages >= pageSelected + lookAheadRange) {
      // eg: pageSelected(2), lookAheadRange(10), number pages(15)
      if (pageSelected <= pageSelectedRangeVal) {
        pagesArray.splice(spliceVal);
      } else {
        pagesArray.splice(pageSelected + lookAheadRange);
      }
    }
    if (pageSelected > 1) {
      // eg: pageSelected(2), lookAheadRange(10), number pages(11)
      if (pageSelected <= numberOfPages - pageSelectedRangeVal) {
        pagesArray.splice(0, pageSelected - pageSelectedRangeVal);
      } else {
        pagesArray.splice(0, pageSelected - 1 - lookAheadRange);
      }
    }
  }

  // set active class of page button
  const pagePosition = Math.ceil(articleListPosition / 200);
  useEffect(() => {
    setPageSelected(pagePosition);
  }, [articleListPosition]);

  const pageHandler = (e) => {
    e.preventDefault();
    setArticleListPosition(e.target.value - 200 + 1);
  };

  return (
    <span>
      {numberOfPages === 1 ? (
        <span>1</span>
      ) : (
        pagesArray.map((page) => (
          <button
            key={page.val}
            value={page.ahead}
            onClick={pageHandler}
            id={page.val}
            className={
              page.val === pageSelected ? "btn-primary" : "btn-secondary"
            }
          >
            {page.val}
          </button>
        ))
      )}
    </span>
  );
};

export default Pages;
